import React from 'react';
import Modal from 'react-modal';

import './NewProjectModal.css';
import { getTranslation } from '../../assets/creator/translations';
const NewProjectModal = (props) => (
    <Modal
        isOpen={props.show}
        onRequestClose={props.onCancel}
        ariaHideApp={false}
        contentLabel="Options"
        className="new-project-modal"
        overlayClassName="overlay"
        shouldCloseOnOverlayClick={true}
    >
        <p className="new-project-modal__header">{getTranslation("NewProjectPromptTitle")}</p>
        <p className="new-project-modal__text">{getTranslation("NewProjectAllChangesWillBeLost")}</p>
        <div>
            <button
                onClick={props.onCancel}
                className="new-project-modal__button new-project-modal__button--non-emphasized"
            >
                {getTranslation("No")}
            </button>
            <button
                onClick={props.onConfirm}
                className="new-project-modal__button new-project-modal__button--emphasized"
            >
                {getTranslation("Yes")}
            </button>
        </div>
    </Modal>
)


export default NewProjectModal;
